import { JSONObject } from 'module/types/common';
import { useAuxiliaryPanel } from 'module/ui/components/templates/argon/auxiliary-panel-utils';
import { useMemo } from 'react';
import { AskAiCommandOptions } from './commands/types';
import { AskAiCommandProcessor } from './ui/command-processor/processor';

// TODO: update props based on usage from other locations
type Props = {
  documentId: number;
};
export const useDefaultAskAiConfig = ({
  documentId,
}: Props): AskAiCommandOptions => {
  const { setContent, clearContent } = useAuxiliaryPanel();

  return useMemo(
    () => ({
      processAskAiRequest: ({ payload, editor, onCancel, onComplete }) => {
        const onClose = () => {
          clearContent();
          onCancel();
        };
        const onUpdate = (content: JSONObject[]) => {
          clearContent();
          onComplete(content);
        };

        setContent(
          <AskAiCommandProcessor
            documentId={documentId}
            editor={editor}
            onClose={onClose}
            request={payload}
            updateContent={onUpdate}
          />,
        );
      },
    }),
    [setContent, documentId, clearContent],
  );
};
